<template>
  <div class="app-container">
    <el-card v-if="form">
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="title-box"><span class="txt1">基本信息</span></div>
      <el-descriptions>
        <el-descriptions-item label="编号">{{form.id}}</el-descriptions-item>
        <el-descriptions-item label="姓名">{{form.realName}}</el-descriptions-item>
        <el-descriptions-item label="头像"><el-image style="width: 50px; height: 50px" :src="form.headImg" :preview-src-list="[form.headImg]"></el-image></el-descriptions-item>
        <el-descriptions-item label="性别"> {{form.sex === 1?'男':(form.sex === 2?'女':'')}}</el-descriptions-item>
        <el-descriptions-item label="登录账号">{{form.userName}}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{form.mobile}}</el-descriptions-item>
        <el-descriptions-item label="工作状态">{{form.workStatus === 10?'在线':(form.workStatus === 20?'离线':'离开')}}</el-descriptions-item>
      </el-descriptions>
      <div class="title-box"><span class="txt1">服务信息</span></div>
      <el-descriptions>
        <el-descriptions-item label="总会客数">{{form.conversationCount || 0}}</el-descriptions-item>
        <el-descriptions-item label="今日会客数">{{form.conversationCountForToday|| 0}}</el-descriptions-item>
        <el-descriptions-item label="本周会客数">{{form.conversationCountForThisWeek|| 0}}</el-descriptions-item>
        <el-descriptions-item label="本月会客数">{{form.conversationCountForThisMonth|| 0}}</el-descriptions-item>
        <el-descriptions-item label="本月好评">{{form.positiveCommentCountForThisMonth || 0}}</el-descriptions-item>
        <el-descriptions-item label="本月差评">{{form.negativeCommentCountForThisMonth || 0}}</el-descriptions-item>
        <el-descriptions-item label="总好评数">{{form.positiveCommentCount || 0}}</el-descriptions-item>
        <el-descriptions-item label="总差评数">{{form.negativeCommentCount || 0}}</el-descriptions-item>
        <el-descriptions-item label="风控次数">{{form.riskControlCount || 0}}</el-descriptions-item>
      </el-descriptions>
      <div class="title-box"><span class="txt1">其他信息</span></div>
      <el-descriptions>
        <el-descriptions-item label="上次在线时间">{{form.lastOnlineTime}}</el-descriptions-item>
        <el-descriptions-item label="入职时间">{{form.entryTime}}</el-descriptions-item>
        <el-descriptions-item label="离职时间" v-if="form.status === 30">{{form.resignTime}}</el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
import custServiceStaffApi from '@/api/customer/custServiceStaff'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null,
    }
  },
  created() {
    this.getDetails()
  },
  methods: {
    getDetails() {
      custServiceStaffApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;
      })
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  }

}
</script>

<style lang="scss" scoped>
.custom {
  font-size: 14px;
  color: #2e2f3e;
  padding: 20px;
  margin: 10px 0;
  &.bg {
    // border-bottom: 1px solid #CCE2D1
    background-color: #eff8fd;
  }
}
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.oppr-btn {
  text-align: right;
  margin-bottom: 20px;
}
</style>
